import { invalidateHierarchyRoster } from './hierarchyRoster.ts';

export const AGENT_SUMMARY_REFRESH_EVENT = 'refresh-agent-summary';

export function requestAgentSummaryRefresh() {
    invalidateHierarchyRoster();
    window.dispatchEvent(new Event(AGENT_SUMMARY_REFRESH_EVENT));
}
